"use strict";
// Copyright 2020-2022 SubQuery Pte Ltd authors & contributors
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderAsyncArray = exports.renderAsync = void 0;
function renderAsync(data, handlers) {
    if (data.data !== undefined) {
        try {
            return handlers.data(data.data, data);
        }
        catch (e) {
            // TODO not sure this is desired behaviour
            return handlers.error(e);
        }
    }
    else if (data.error) {
        return handlers.error(data.error);
    }
    else if (data.loading) {
        return handlers.loading();
    }
    return null;
}
exports.renderAsync = renderAsync;
function renderAsyncArray(data, handlers) {
    if (data.data !== undefined) {
        try {
            if (data.data === null || (Array.isArray(data.data) && !data.data.length)) {
                return handlers.empty();
            }
            return handlers.data(data.data, data);
        }
        catch (e) {
            // TODO not sure this is desired behaviour
            return handlers.error(e);
        }
    }
    if (data.error) {
        return handlers.error(data.error);
    }
    else if (data.loading) {
        return handlers.loading();
    }
    return null;
}
exports.renderAsyncArray = renderAsyncArray;
//# sourceMappingURL=renderAsync.js.map